export default __webpack_public_path__ + "static/media/worldCup2022-logo.f1764342.png";